import { inject, observer } from "mobx-react";
import React from "react";
import { Table, Row, Col } from "react-bootstrap";
import { action, toJS } from "mobx";
import { NavigateFunction } from "react-router-dom";
import ProductAttributeSection from "./ProductAttributeSection";
import Plus from "../../../../../../images/products/plus.svg";
import EditIcon from "../../../../../../images/products/edit-blue.svg";
import RefreshIcon from "../../../../../../images/products/refresh-blue.svg";
import Close from "../../../../../../images/products/close.svg";
import ProductSelectAttribute from "./ProductSelectAttribute";
import ProductStore from "../ProductStore";
import {
  CustomLabel,
  FlexContainer,
  IconButton,
  Input,
  nameof,
  StyledTable,
  StyledTooltip,
  theme,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import {
  ProductAttributeInputModel,
  ProductAttributeMappingsInput,
} from "../../../shared/models";
import {
  DescriptionCell,
  LabelCell,
  ProductDetailWrapper,
} from "../../../shared/styles";

type State = { detailPageData: any };
type Props = {
  productStore?: ProductStore;
  navigate: NavigateFunction;
};

@inject("productStore")
@observer
class ProductVariantPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  @action
  onAddAttribute() {
    this.props.productStore?.toggleShowAttribute();
  }

  get addAttribute(): React.ReactNode {
    if (!this.props.productStore?.showAddAttribute) return <></>;

    return (
      <ProductSelectAttribute
        onClose={() => this.props.productStore?.toggleShowAttribute()}
      />
    );
  }

  input(
    disabled: boolean,
    value: string,
    hasError: boolean,
    index: number,
    fieldName: keyof ProductAttributeMappingsInput
  ) {
    return (
      <Input
        disabled={disabled}
        value={value}
        error={hasError}
        id={`txt_${fieldName}`}
        type="text"
        onChange={(e) =>
          this.onTextInputChange(e.target.value, index, fieldName)
        }
      />
    );
  }

  inputCheckBox(
    checked: boolean,
    label: string,
    fieldName: keyof ProductAttributeInputModel
  ) {
    return (
      <Input
        value={checked}
        label={label}
        error={false}
        id={`chk_${fieldName}`}
        type="checkbox"
        onChange={(e) => this.onCheckBoxChange(e.target.checked, fieldName)}
        className="styled-chkbox variant-chkbx-label"
      />
    );
  }

  onTextInputChange(
    value: string,
    index: number,
    fieldName: keyof ProductAttributeMappingsInput
  ) {
    const optionToUpdate = [
      ...(this.props.productStore?.attributeInputs?.options || []),
    ];

    switch (fieldName) {
      case nameof<ProductAttributeMappingsInput>("sku"):
        optionToUpdate[index].sku = value;
        break;
      case nameof<ProductAttributeMappingsInput>("barCode"):
        optionToUpdate[index].barCode = value;
        break;
      case nameof<ProductAttributeMappingsInput>("price"):
        optionToUpdate[index].price = value;
        break;
      case nameof<ProductAttributeMappingsInput>("originalPrice"):
        optionToUpdate[index].originalPrice = value;
        break;
      case nameof<ProductAttributeMappingsInput>("cost"):
        optionToUpdate[index].cost = value;
        break;
      case nameof<ProductAttributeMappingsInput>("onHand"):
        optionToUpdate[index].onHand = value;
        break;
    }

    this.props.productStore?.updateAttributeInputs(
      new ProductAttributeInputModel({
        ...this.props.productStore?.attributeInputs,
        options: optionToUpdate,
      })
    );
  }

  onCheckBoxChange(
    checked: boolean,
    fieldName: keyof ProductAttributeInputModel
  ) {
    this.props.productStore?.updateAttributeInputs(
      new ProductAttributeInputModel({
        ...this.props.productStore?.attributeInputs,
        [fieldName]: checked,
      })
    );
  }

  hasError(
    index: number,
    fieldName: keyof ProductAttributeMappingsInput
  ): boolean {
    return (
      this.props.productStore?.attributeInputs?.errors?.find(
        (x) => x.index == index && x.field === fieldName
      ) !== undefined
    );
  }

  @action
  deleteSelectedAttribute(idx: number) {
    this.props.productStore?.deleteSelectedAttribute(idx);
  }

  toggleRemoveOption(optionIndex: number, remove: boolean) {
    this.props.productStore?.toggleRemoveOption(optionIndex, remove);
  }

  get isStandardPricing() {
    return this.props.productStore?.isStandardPricing();
  }

  get headerRow() {
    if (!this.isStandardPricing) return null;
    const priceByVariant =
      this.props.productStore?.attributeInputs?.priceByVariant === true;
    const originalPriceByVariant =
      this.props.productStore?.attributeInputs?.originalPriceByVariant === true;
    const costByVariant =
      this.props.productStore?.attributeInputs?.costByVariant === true;
    return (
      <Row className="variant-Options">
        <Col md={11}>
          <FlexContainer
            justifyContent="flex-end"
            alignItems="center"
            spacing={30}
          >
            {this.inputCheckBox(
              priceByVariant,
              "Price by Variant",
              nameof<ProductAttributeInputModel>("priceByVariant")
            )}

            {this.inputCheckBox(
              originalPriceByVariant,
              "Original Price by Variant",
              nameof<ProductAttributeInputModel>("originalPriceByVariant")
            )}
            {this.inputCheckBox(
              costByVariant,
              "Cost by Variant",
              nameof<ProductAttributeInputModel>("costByVariant")
            )}
          </FlexContainer>
        </Col>
      </Row>
    );
  }

  render(): React.ReactNode {
    const priceByVariant =
      this.props.productStore?.attributeInputs?.priceByVariant === true;
    const originalPriceByVariant =
      this.props.productStore?.attributeInputs?.originalPriceByVariant === true;
    const costByVariant =
      this.props.productStore?.attributeInputs?.costByVariant === true;
    const totalSelected =
      this.props.productStore?.selectedAttributes?.length || 0;
    const showOnHand =
      this.props.productStore?.attributeInputs?.showOnHand === true;
    console.log(this.props.productStore?.attributeInputs);
    return (
      <ProductDetailWrapper>
        <FlexContainer fxLayout="column" spacing={10}>
          <CustomLabel fontSize="22px" fontWeight="600">
            Attributes
          </CustomLabel>
          <CustomLabel fontSize={"14px"} margin="0px 0px 10px">
            Create Attributes like Color, Size, Style and more. Each Attribute{" "}
            <br />
            will create Variants that you can modify.
          </CustomLabel>
        </FlexContainer>
        <ProductAttributeSection
          onEdit={(idx) => {
            this.props.productStore?.toggleShowAttribute(idx);
          }}
          onDelete={(idx) => this.deleteSelectedAttribute(idx)}
          attributes={toJS(this.props.productStore?.selectedAttributes) || []}
          onSortChange={(attributes) =>
            this.props?.productStore?.updateSortedSelectedAttributes(attributes)
          }
        />

        {this.addAttribute}

        {totalSelected < 3 && (
          <FlexContainer className="label-description-row variant-add-package">
            <LabelCell>
              <IconButton
                className="add-package-btn"
                color={theme.palette.info.dark}
                type="button"
                onClick={() => this.onAddAttribute()}
                gap="4px"
                height="23px"
              >
                <img src={Plus} alt="Add Row" />
                <span> Add Attribute</span>
              </IconButton>
            </LabelCell>
          </FlexContainer>
        )}

        {this.props.productStore?.selectedAttributes &&
          this.props.productStore?.selectedAttributes?.length > 0 && (
            <>
              <FlexContainer spacing={15} fxLayout="column">
                <CustomLabel fontSize="22px" fontWeight="600">
                  Variants
                </CustomLabel>
                <div>
                  <CustomLabel fontSize={"14px"}>
                    Set individual Price, Original Price, Cost, Inventory On
                    Hand, SKU and
                    <br /> Barcode for each Variant. Click variant or
                    <img src={EditIcon} className="variant-desc-edit" />
                    to customize further.
                  </CustomLabel>
                </div>
              </FlexContainer>
              {this.headerRow}

              <FlexContainer className="label-description-row">
                <DescriptionCell>
                  <StyledTable className="variant-table">
                    <Table bsPrefix="styled-table" responsive>
                      <thead>
                        <th>VARIANT</th>
                        {priceByVariant && <th>PRICE</th>}
                        {originalPriceByVariant && <th>ORIGINAL PRICE</th>}
                        {costByVariant && <th>COST</th>}
                        {showOnHand && <th>ON HAND</th>}
                        {/* <th>AVAILABLE</th> */}
                        <th>SKU</th>
                        <th>BARCODE</th>
                        <th></th>
                      </thead>
                      <tbody>
                        {this.props.productStore?.attributeInputs?.options?.map(
                          (attr, idx) => {
                            return (
                              <tr key={idx}>
                                <td>
                                  <StyledTooltip tooltipText={attr.name}>
                                    <div className="overflow-ellipsis clickable">
                                      {attr.name}
                                    </div>
                                  </StyledTooltip>
                                </td>
                                {priceByVariant && (
                                  <td>
                                    <FlexContainer
                                      fxLayout="row"
                                      className="dollar-input"
                                      justifyContent="center"
                                    >
                                      <div>
                                        {this.input(
                                          attr.isRemoved,
                                          attr.price,
                                          this.hasError(
                                            idx,
                                            nameof<ProductAttributeMappingsInput>(
                                              "price"
                                            )
                                          ),
                                          idx,
                                          nameof<ProductAttributeMappingsInput>(
                                            "price"
                                          )
                                        )}
                                      </div>
                                    </FlexContainer>
                                  </td>
                                )}

                                {originalPriceByVariant && (
                                  <td>
                                    <FlexContainer
                                      fxLayout="row"
                                      className="dollar-input"
                                      justifyContent="center"
                                    >
                                      <div>
                                        {this.input(
                                          attr.isRemoved,
                                          attr.originalPrice,
                                          this.hasError(
                                            idx,
                                            nameof<ProductAttributeMappingsInput>(
                                              "originalPrice"
                                            )
                                          ),
                                          idx,
                                          nameof<ProductAttributeMappingsInput>(
                                            "originalPrice"
                                          )
                                        )}
                                      </div>
                                    </FlexContainer>
                                  </td>
                                )}

                                {costByVariant && (
                                  <td>
                                    <FlexContainer
                                      fxLayout="row"
                                      className="dollar-input"
                                      justifyContent="center"
                                    >
                                      <div>
                                        {this.input(
                                          attr.isRemoved,
                                          attr.cost,
                                          this.hasError(
                                            idx,
                                            nameof<ProductAttributeMappingsInput>(
                                              "cost"
                                            )
                                          ),
                                          idx,
                                          nameof<ProductAttributeMappingsInput>(
                                            "cost"
                                          )
                                        )}
                                      </div>
                                    </FlexContainer>
                                  </td>
                                )}
                                {showOnHand && (
                                  <td>
                                    <FlexContainer
                                      fxLayout="row"
                                      justifyContent="center"
                                    >
                                      <div>
                                        {this.input(
                                          attr.isRemoved,
                                          attr.onHand,
                                          this.hasError(
                                            idx,
                                            nameof<ProductAttributeMappingsInput>(
                                              "onHand"
                                            )
                                          ),
                                          idx,
                                          nameof<ProductAttributeMappingsInput>(
                                            "onHand"
                                          )
                                        )}
                                      </div>
                                    </FlexContainer>
                                  </td>
                                )}
                                {/* <td>
                                  {this.input(
                                    attr.isRemoved,
                                    attr.available,
                                    this.hasError(
                                      idx,
                                      nameof<ProductAttributeMappingsInput>(
                                        "available"
                                      )
                                    ),
                                    idx,
                                    nameof<ProductAttributeMappingsInput>(
                                      "available"
                                    )
                                  )}
                                </td> */}
                                <td>
                                  {this.input(
                                    attr.isRemoved,
                                    attr.sku,
                                    this.hasError(
                                      idx,
                                      nameof<ProductAttributeMappingsInput>(
                                        "sku"
                                      )
                                    ),
                                    idx,
                                    nameof<ProductAttributeMappingsInput>("sku")
                                  )}
                                </td>
                                <td>
                                  {this.input(
                                    attr.isRemoved,
                                    attr.barCode,
                                    this.hasError(
                                      idx,
                                      nameof<ProductAttributeMappingsInput>(
                                        "barCode"
                                      )
                                    ),
                                    idx,
                                    nameof<ProductAttributeMappingsInput>(
                                      "barCode"
                                    )
                                  )}
                                </td>
                                <td>
                                  {idx > 0 && (
                                    <FlexContainer
                                      justifyContent="flex-end"
                                      alignItems="center"
                                      spacing={15}
                                    >
                                      <button className="delete-row-btn">
                                        <StyledTooltip tooltipText="Edit">
                                          <img src={EditIcon} alt="Edit Row" />
                                        </StyledTooltip>
                                      </button>
                                      <button className="delete-row-btn">
                                        <StyledTooltip
                                          tooltipText={`${attr.isRemoved ? "Restore" : "Delete"}`}
                                        >
                                          <img
                                            src={
                                              attr.isRemoved
                                                ? RefreshIcon
                                                : Close
                                            }
                                            alt={
                                              attr.isRemoved
                                                ? "Restore"
                                                : "Delete Row"
                                            }
                                            onClick={() =>
                                              this.toggleRemoveOption(
                                                idx,
                                                !attr.isRemoved
                                              )
                                            }
                                          />
                                        </StyledTooltip>
                                      </button>
                                      {/* <button className="delete-row-btn">
                                                        <img src={RefreshIcon} alt="Delete Row" />
                                                    </button> */}
                                    </FlexContainer>
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </Table>
                  </StyledTable>
                </DescriptionCell>
              </FlexContainer>
            </>
          )}
      </ProductDetailWrapper>
    );
  }
}
export default withRouter(ProductVariantPage);
